import { render } from "./App.vue?vue&type=template&id=61a4223b"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=61a4223b&lang=css"

import exportComponent from "C:\\Users\\EZZKAH\\IdeaProjects\\linklist\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__